export default __webpack_public_path__ + "static/media/5s.03b3585b.png";